import * as React from 'react';
import { CaseResult } from 'app/area/case-report/case-listing/types-store';
import { FavouriteDefinition } from 'app/types-shared';
import { BowtieListingResultOrInfo } from 'app/area/case-report/bowtie-listing';
import { useLoadPage, usePagination } from 'app/area/case-report/bowtie-listing/hooks';
import { useEffect } from 'react';
import './bowtie-listing.scss';

interface BowtieListingProps {
  translation: any;
  autoExecute: boolean;
  results?: CaseResult[];
  totalNumberOfResults?: number;
  fetching: boolean;
  workingDefinition: FavouriteDefinition;
  maxOptionsPerPage?: number;
  minimumOptionsNeededBeforePagination ?: number;
  executeFailed?: JSX.Element;
}

export const BowtieListing = ({
  translation, 
  autoExecute,
  results, 
  totalNumberOfResults, 
  fetching,
  workingDefinition,
  maxOptionsPerPage = 1,
  minimumOptionsNeededBeforePagination = 1,
  executeFailed
}: BowtieListingProps) => {
 
  const {
    loadPage
  } = useLoadPage(
        workingDefinition
    );
    
  const {
    numberOfPages,
    shouldPaginate,
    currentPage,
    first,
    previous,
    next,
    last
  } = usePagination(totalNumberOfResults, maxOptionsPerPage, minimumOptionsNeededBeforePagination);
  
  useEffect(() => { 
    autoExecute && loadPage(currentPage, maxOptionsPerPage);
  }, [currentPage, maxOptionsPerPage, autoExecute, loadPage]);

  if(executeFailed) {
    return executeFailed;
  }
  
  return <BowtieListingResultOrInfo
    translation={translation}
    autoExecute={autoExecute}
    results={results}
    fetching={fetching}
    workingDefinition={workingDefinition}
    maxOptionsPerPage={maxOptionsPerPage}
    numberOfPages={numberOfPages}
    shouldPaginate={shouldPaginate}
    currentPage={currentPage}
    first={first}
    previous={previous}
    next={next}
    last={last}
  />;
};
